// aws-sdk requires global to exist
window.global = window;

